import { useEffect, useState } from 'react';

const AgePopup = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const isConfirmed = localStorage.getItem('ageConfirmed');

        if (!isConfirmed) {
            setIsVisible(true);
        }
    }, []);

    const handleConfirm = () => {
        localStorage.setItem('ageConfirmed', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={`age-popup ${isVisible ? 'active' : ''}`} id="agePopup">
            <div className="age-popup-panel">
                <p className="age-popup-text">
                    18+ ONLY | VIRTUAL CREDITS | NO CASH VALUE
                </p>
                <button
                    type="button"
                    className="age-popup-btn"
                    onClick={handleConfirm}
                >
                    I Confirm
                </button>
            </div>
        </div>
    );
};

export default AgePopup;